import { render, staticRenderFns } from "./zhiyuanzhefengcai.vue?vue&type=template&id=c5229f10&scoped=true"
import script from "./zhiyuanzhefengcai.vue?vue&type=script&lang=js"
export * from "./zhiyuanzhefengcai.vue?vue&type=script&lang=js"
import style0 from "./zhiyuanzhefengcai.vue?vue&type=style&index=0&id=c5229f10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5229f10",
  null
  
)

export default component.exports